import Axios from "@/plugins/Axios";

const BASE_URL = "chat";

export class ChatService {
  async listarConversas() {
    const response = await Axios().get(`${BASE_URL}/conversas`);
    return response.data;
  }

  async exibirConversa(conversaId) {
    const response = await Axios().get(`${BASE_URL}/conversas/${conversaId}`);
    return response.data;
  }

  async iniciarConversa(destinatarioId, conteudo) {
    const response = await Axios().post(`${BASE_URL}/conversas`, {
      destinatario_id: destinatarioId,
      conteudo,
    });
    return response.data;
  }

  async enviarMensagem(conversaId, conteudo) {
    const response = await Axios().post(`${BASE_URL}/conversas/${conversaId}/mensagens`, {
      conteudo,
    });
    return response.data;
  }

  async listarColaboradores() {
    const response = await Axios().get(`${BASE_URL}/colaboradores`);
    return response.data;
  }
}

export default new ChatService();
